import React, { useEffect, useState } from "react";
import DashboardLayout from "../common/DashboardApp";
import Loader from "../common/Loader";
import { getAppliedJobData } from "../../../service/api";

const JobsApplied = () => {
  const [jobData, setJobData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const data = await getAppliedJobData();
        setJobData(data?.data || []);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  if (loading) return <Loader />;

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div class="titlSectionu userpaneltitle text-left position-relative">
          <h2>Job Applied</h2>
          <p>A list of applied jobs</p>
        </div>

        <div className="row">
          {jobData.length > 0 ? (
            jobData.map((job) => (
              <div className="col-md-6 col-lg-4" key={job.jobPostId}>
                <div className="astrocard">
                  <div className="astrocContainer">
                    <div className="astrohead">
                      <div className="astroImg">
                        <a
                          href={`/jobdetails/${job.jobPostId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={
                              job.companyImage
                                ? job.companyImage
                                : "/assets/img/company-profiles/image-1.png"
                            }
                            alt="Company"
                            style={{ width: "150%" }}
                          />
                        </a>
                      </div>
                    </div>
                    <div className="astroDetails">
                      <div className="astroName">
                        <a
                          href={`/jobdetails/${job.jobPostId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <h4>
                            {job.jobTitle}{" "}
                            <img
                              src="/assets/img/icons/icon-bold.svg"
                              className="verifiedCheck"
                              alt="Verified"
                            />
                          </h4>
                        </a>
                        {/* <ul className="astroAcheiver companyName">
                          <li>
                            <img
                              src="/assets/img/icons/office.svg"
                              width="20"
                              alt="Company"
                            />
                            <p>{job.companyName}</p>
                          </li>
                        </ul> */}
                        <div className="astroinfo">
                          <li>
                            <img
                              src="/assets/img/icons/office.svg"
                              alt="Location"
                            />
                            <span>{job.companyName}</span>
                          </li>
                          <li>
                            <img
                              src="/assets/img/icons/location-.svg"
                              alt="Location"
                            />
                            <span>{job.city}, {job.state}</span>
                          </li>
                        </div>
                        <div className="astroinfo">
                          <li>
                            <img
                              src="/assets/img/icons/calender.svg"
                              alt="Posted"
                            />
                            <span>Posted {job.jobPosted}</span>
                          </li>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-2 align-item-center w-100 joblistfooter">
                    <a
                      href={`/jobdetails/${job.jobPostId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mainbtn"
                    >
                      View Job
                    </a>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="alert alert-info text-center">
                You have not applied to any Jobs.
              </div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default JobsApplied;
